import { envProperties } from 'utils/EnvironmentProperties'

import { InSight } from './api'

export const inSightApi = new InSight(envProperties.InsightBaseUrl)